<template>
  <div>
    <v-banner
      :value="banner"
      class="text-center error--text font-weight-bold"
      shaped
    >
      <span
        v-if="!$route.path.includes('PRAPARE')"
        v-html="$t(`information.bhEmergency`)"
      ></span>
      <span
        v-if="$route.path.includes('PRAPARE')"
        v-html="$t(`information.prapareInfo`)"
      ></span>
      <!-- <template v-slot:actions>
        <v-btn text color="primary" @click="banner = !banner">
          Dismiss
        </v-btn>
      </template> -->
    </v-banner>
    <Status v-if="this.$route.params.id && !this.$route.params.form" />
    <v-container>
      <v-fade-transition mode="in-out" hide-on-leave>
        <template v-if="this.$route.params.id && this.$route.params.form">
          <PHQ
            v-if="
              this.$route.params.form.toLowerCase() == 'phq' ||
                this.$route.params.form.toLowerCase() == 'phq-2'
            "
            :form-id="formId"
            :expiration="expiration"
            @formSuccess="updateModal"
          />
          <PHQ9
            v-if="this.$route.params.form.toLowerCase().includes('phq-9')"
            :form-id="formId"
            :expiration="expiration"
            @formSuccess="updateModal"
          />
          <PHQA
            v-if="this.$route.params.form.toLowerCase().includes('phq-a')"
            :form-id="formId"
            :expiration="expiration"
            @formSuccess="updateModal"
          />
          <SBIRT
            v-if="this.$route.params.form.toLowerCase() === 'sbirt'"
            :form-id="formId"
            :expiration="expiration"
            @formSuccess="updateModal"
          />
          <DAST
            v-if="this.$route.params.form.toLowerCase() === 'dast'"
            :form-id="formId"
            :expiration="expiration"
            @formSuccess="updateModal"
          />
          <AUDIT
            v-if="this.$route.params.form.toLowerCase() === 'audit'"
            :form-id="formId"
            :expiration="expiration"
            @formSuccess="updateModal"
          />
          <CRAFFT
            v-if="this.$route.params.form.toLowerCase() === 'crafft'"
            :form-id="formId"
            :expiration="expiration"
            @formSuccess="updateModal"
          />
          <GAD
            v-if="this.$route.params.form.toLowerCase() === 'gad-7'"
            :form-id="formId"
            :expiration="expiration"
            @formSuccess="updateModal"
          />
          <PRAPARE
            v-if="this.$route.params.form.toLowerCase() === 'prapare'"
            :form-id="formId"
            :expiration="expiration"
            @formSuccess="updateModal"
          />
          <SDOH
            v-if="this.$route.params.form.toLowerCase() === 'sdoh'"
            :form-id="formId"
            :expiration="expiration"
            @formSuccess="updateModal"
          />
          <PatientDemographics
            v-if="this.$route.params.form.toLowerCase() === 'pdg'"
            :form-id="formId"
            :expiration="expiration"
            @formSuccess="updateModal"
          />
        </template>
      </v-fade-transition>
    </v-container>
    <success-modal v-if="modal" :modal.sync="modal">
      <template #title>
        {{ $t("modal.success") }}
      </template>
      <template #content>
        {{ $t("heading.navigationHome") }}
      </template>
      <template #homeButton>
        {{ $t("modal.backHome") }}
      </template>
    </success-modal>
    <!-- <SDOH /> -->
    <!-- <PatientDemographics /> -->
  </div>
</template>

<script>
// @ is an alias to /src
import Status from "@/views/Status";
import SuccessModal from "../components/forms/Modal.vue";

export default {
  name: "Forms",
  components: {
    Status,
    SuccessModal,
    PHQ: () => import("@/components/forms/PHQ.vue"),
    PHQ9: () => import("@/components/forms/PHQ9"),
    PHQA: () => import("@/components/forms/PHQA"),
    SBIRT: () => import("@/views/SBIRT"),
    AUDIT: () => import("@/components/forms/AUDIT"),
    DAST: () => import("@/components/forms/DAST"),
    CRAFFT: () => import("@/components/forms/CRAFFT"),
    GAD: () => import("@/components/forms/GAD7"),
    PRAPARE: () => import("@/components/forms/PRAPARE"),
    SDOH: () => import("@/components/forms/SDOH"),
    PatientDemographics: () => import("@/components/forms/PatientDemographics"),
  },
  i18n: {
    messages: {
      en: {
        modal: {
          success: "Responses Successfully Submitted",
          backHome: "Back to Home Page",
        },
      },
      es: {
        modal: {
          success: "Respuestas Enviadas",
          backHome: "Volver a la página de inicio",
        },
      },
    },
  },
  props: {
    expiration: {
      default: null,
      type: String,
    },
    formId: {
      default: null,
      type: String,
    },
  },
  data() {
    return {
      banner: true,
      modal: false,
    };
  },
  methods: {
    updateModal(value) {
      this.modal = value;
    },
  },
};
</script>
